import { Location } from '../types';

type GetLocationById = (
    locationId: number,
    sublocationId?: number,
    locations?: Record<number, Location>
) => string;

export const getLocationById: GetLocationById = (locationId, sublocationId, locations = {}) => {
    const location = locations[locationId]?.name || '';
    const sublocation = locations[locationId]?.sublocations?.[sublocationId]?.name || '';
    const dash = sublocation ? ' - ' : '';

    return [location, dash, sublocation].filter(item => item).join('');
};
